import axios from 'axios'

const request = axios.create({
  baseURL: window.drupalSettings.idfive_calendar_client.options.api_url,
  withCredentials: false,
  headers: {
    'Access-Control-Allow-Origin' : 'https://agnr.umd.edu',
    'Access-Control-Allow-Methods':'GET',
    'Content-Type': 'application/json'
  }
})

request.interceptors.response.use(
  (response) => {
    window.response = response

    if (response.status === 200) {
      return response.data
    }
    return Promise.reject(response)
  },
  (error) => {
    console.log(error.response ? error.response.data.message : error.message)
    return error
  }
)

export default request
